<template>
    <div class="latest-products-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs-12">
                    <div class="last-projects">
                        <div class="section-header">
                            <div class="col-xs-12 text-center">
                                <h2>آخر الأعمال</h2>

                                <div class="loader" v-if="loading">
                                    <i class="fa fa-spin fa-circle-o-notch"></i>
                                </div>
                            </div>
                        </div>
                        <div class="body">
                            <div class="products-container">
                                <div v-for="product in products" v-bind:key="product.Id"
                                     class="col-md-3 col-sm-6 col-xs-6 col-xxs-12">
                                    <product-v2 :product="product"></product-v2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 center-horizontally-flex">
                    <router-link to="/products" class="btn btn-custom">
                        <span>عرض الكل</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import ProductV2 from '@/components/products/productv2';
    import axios from 'axios'

    export default {
        name: "LatestProducts",

        data: () => ({
            products: [],
            loading: true,
        }),

        mounted() {
            axios.get(apiHost + "/products/featured")
                .then((response) => {
                    this.products = response.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => this.loading = false);
        },

        components: {
            ProductV2
        },
    }

</script>


<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .latest-products-page {
        position: relative;
        clear: both;
    }

    .last-projects {
        .section-header {
            overflow: auto;
            margin-bottom: 30px;

            .loader {
                font-size: 50px;
                margin-top: 50px;
            }
        }
        width: 100%;
        padding: 15px;
        @include text-align($dir);
        direction: $dir;
        @include float-left($dir);
        font-size: 21px;
        .section-title {
            border-bottom: 1px solid silver;
            padding-bottom: 5px;
            @include padding-left(15px, $dir);
            .fa {
                @include margin-right(10px, $dir);
                color: $main-color;
            }
        }
        .body {
            margin-top: 50px;
            margin-bottom: 50px;

            .products-container {
                & > div {
                    padding-left: 10px;
                    padding-right: 10px;
                    margin-bottom: 10px;
                    @include float-left($dir);

                }
            }
        }

    }

    .center-horizontally-flex {
        margin-top: 20px;
        margin-bottom: 20px;
        .btn-custom {
            width: 30%;

            @media(max-width: 767px) {
                width: 50%;
            }
            @media(max-width: 480px) {
                width: 90%;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/home/latest-products.vue